import { donationInterruptPage } from './pages/donationInterruptPage/donationInterruptPage';
import { Alert } from '../modules/alert';
import { showHidePassword } from './modules/show-hide-password';
import { quickDonate } from './pages/quickDonate/quickDonatePage';
import CartTimer from './modules/cart-timer';
import './modules/country-state-zip-forms';
import PromoInterface from './../ace/modules/promo-interface';


new CartTimer();
donationInterruptPage();
showHidePassword();
quickDonate();

// Global registry for modal instances - allows programmatic access to modals
if (!window.__aceModalRegistry) {
    (window as any).__aceModalRegistry = new Map();
}

const initializeGenericComponents = () => {



    const promoEls = [].slice.call(document.querySelectorAll('[data-promo]')) as HTMLElement[];
    promoEls.forEach(promoEl => {
        new PromoInterface(promoEl);
    })

}

initializeGenericComponents();